export default "__VITE_ASSET__boOGf6us__"